import React, { useState, useContext } from "react";
import { Box, Typography } from "@mui/material";
import { getColors } from "../../themes/theme";
import { ThemeContext } from "../../context/ThemeContext";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { Add } from "@mui/icons-material";
import { EditConditionDialog } from "../condition/EditConditionDialog";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import axios from "axios";
import { useSnackbar } from "notistack";
import { CopyConditionDialog } from "./CopyConditionDialog";

export const ConditionItem = ({
  id,
  area,
  acondition,
  bmname,
  onConditionUpdate,
}) => {
  const { token } = useAuthContext();
  let img;
  if (bmname) {
    img = require(`../../assets/condition/${bmname}.png`);
  }
  const { darkMode } = useContext(ThemeContext);
  const [openEditDialog, setOpenEditDialog] = useState(false); // New state for confirmation dialog
  const [openCopyDialog, setOpenCopyDialog] = useState(false); // New state for confirmation dialog
  const [conditionToEdit, setConditionToEdit] = useState(null); // New state for the user to be deleted
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/condition/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setConditionToEdit(response.data);
    setOpenEditDialog(true);
  };

  const handleCopyClick = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/condition/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    setConditionToEdit(response.data);
    setOpenCopyDialog(true);
  };

  const handleCancelEdit = () => {
    setOpenEditDialog(false);
  };

  const handleCancelCopy = () => {
    setOpenCopyDialog(false);
  };

  const handleEditCondition = async (data) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/condition/${data.id}`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      onConditionUpdate(response.data); // Update the parent state
      enqueueSnackbar("Successfully Changed!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to update phase!", { variant: "error" });
    }
  };

  const handleCopyCondition = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/condition`,
        {
          ...data,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      onConditionUpdate(response.data); // Update the parent state
      enqueueSnackbar("Successfully Copied!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy phase!", { variant: "error" });
    }
  };

  const handleDeleteCondition = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/condition/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      onConditionUpdate({ id, deleted: true }); // Notify parent about the deletion
      setOpenEditDialog(false);
      enqueueSnackbar("Successfully Deleted!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to delete phase!", { variant: "error" });
    }
  };

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{
          width: "475px",
          height: "120px",
          padding: 1,
          borderRadius: "5px",
          borderWidth: 1,
          borderStyle: "solid",
          borderColor: darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight,
          background: darkMode
            ? getColors.thumbnnailBgDark
            : getColors.thumbnnailBgLight,
          cursor: "pointer",
          "&:hover": {
            borderColor: darkMode
              ? getColors.thumbnailTextDark
              : getColors.thumbnailTextLight,
          },
        }}
      >
        <Box display={"flex"} alignItems={"center"}>
          <img src={img} alt="img" style={{ width: "100px", height: "75px" }} />
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 500,
              color: darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight,
              mx: 3,
            }}
          >
            {`${acondition} (${area})`}
          </Typography>
        </Box>
        <Box display="flex">
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            width="max-content"
            sx={{
              borderRadius: "50%",
              padding: "20px",
              color: "#009903",
              bgcolor: "#EAFFEF",
              alignItems: "center",
              "&:hover": {
                color: "green",
              },
              ml: 1,
              mr: 2,
            }}
            onClick={handleCopyClick} // Move the onClick handler here
          >
            <Add />
          </Box>
          <Box
            display={"flex"}
            justifyContent={"flex-end"}
            width="max-content"
            sx={{
              borderRadius: "50%",
              padding: "20px",
              color: "#007FFF",
              bgcolor: "#E9F3FF",
              alignItems: "center",
              "&:hover": {
                color: "blue",
              },
              mr: 2,
            }}
            onClick={handleClick} // Move the onClick handler here
          >
            <BorderColorOutlinedIcon />
          </Box>
        </Box>
      </Box>
      <EditConditionDialog
        open={openEditDialog}
        onClose={handleCancelEdit}
        conditionData={conditionToEdit}
        onSave={handleEditCondition}
        onRemove={handleDeleteCondition}
      />
      <CopyConditionDialog
        open={openCopyDialog}
        onClose={handleCancelCopy}
        conditionData={conditionToEdit}
        onSave={handleCopyCondition}
      />
    </>
  );
};
